export function resolveAuthoringRecommendationPreview({ previewRecommendationId, recommendations = [] }) {
    if (!previewRecommendationId) return null
    const item =
        (Array.isArray(recommendations) ? recommendations : []).find(
            (candidate) => candidate?.id === previewRecommendationId
        ) ?? null

    if (!item) return null
    if (item?.kind === "merged-group") return item?.previewRecommendation ?? item?.items?.[0] ?? null
    return item
}
